import { gql, useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useConfig, useCurrentUser, usePusher, } from '@marvelapp/ballpark-application';
import { PusherEvent } from '@marvelapp/core';
const GET_LIVE_SESSIONS_COUNT = gql `
  query getLiveSessionsCount {
    user {
      pk
      company {
        pk
        liveSessionsCount
      }
    }
  }
`;
export function useLiveSessionsCount() {
    var _a, _b, _c;
    const { data, refetch } = useQuery(GET_LIVE_SESSIONS_COUNT);
    const config = useConfig();
    const user = useCurrentUser();
    const { pusher } = usePusher();
    useEffect(() => {
        const channelName = `${config.pusher.userChannelPrefix}${user.pk}`;
        const { bindChannel } = pusher.subscribe(channelName);
        const handleSessionStarted = () => {
            refetch();
        };
        const handleSessionEnded = () => {
            refetch();
        };
        // Refetch count when a new live session starts
        const unbindSessionStarted = bindChannel(PusherEvent.LiveSessionStarted, handleSessionStarted);
        // Refetch count when a live session is ended
        const unbindSessionEnded = bindChannel(PusherEvent.LiveSessionEnded, handleSessionEnded);
        return () => {
            unbindSessionStarted();
            unbindSessionEnded();
        };
    }, [config.pusher.userChannelPrefix, pusher, user.pk, refetch]);
    return (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.user) === null || _a === void 0 ? void 0 : _a.company) === null || _b === void 0 ? void 0 : _b.liveSessionsCount) !== null && _c !== void 0 ? _c : 0;
}
